import Loading from '../../Loading';
import {
    CheckCircleIcon,
    StarIcon,
    XCircleIcon,
} from '@heroicons/react/24/solid';
import TStrings from './Payment.i18n';
import { ReactElement } from 'react';
import ErrorMessageBlock from '~/components/ErrorMessageBlock';

type PaymentProcessorCardProps = {
    enabled?: boolean;
    subtitle1?: string;
    subtitle2?: string;
    className?: string;
    description: string;
    isLoading?: boolean;
    hasInit?: boolean;
    isConnected?: boolean;
    featured?: boolean;
    onConnectClick: () => void;
    icon?: ReactElement;
    buttonText: string;
    error?: string;
};

const PaymentProcessorCard = ({
    className = '',
    description,
    hasInit,
    isConnected,
    isLoading,
    onConnectClick,
    subtitle1,
    subtitle2,
    icon,
    buttonText,
    enabled,
    error,
    featured,
}: PaymentProcessorCardProps) => {
    return (
        <div
            className={`flex flex-col ${className} ${enabled ? '' : 'opacity-75'}`}
        >
            <div className="flex justify-between items-center min-h-20">
                {icon ? <div className="w-[100px]">{icon}</div> : null}
                {enabled && isLoading && <Loading className="ml-7 mr-2" />}
                {!isLoading && (
                    <>
                        {enabled && hasInit && isConnected ? (
                            <div className="text-green-500 flex items-center">
                                <CheckCircleIcon className="w-5 h-5 mr-1" />
                                {TStrings.CONNECTED_BUTTON}
                            </div>
                        ) : (
                            <>
                                {!!error && (
                                    <div className="text-red-500 flex items-center">
                                        <XCircleIcon className="w-5 h-5 mr-1" />
                                        {TStrings.NOT_CONNECTED_BUTTON}
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
            <div className="grow text-gray-500">{description}</div>
            {enabled && hasInit && (
                <div>
                    <button
                        type="button"
                        className={`mt-4 ${isConnected ? 'btn-light-pill' : 'btn-pill'}`}
                        onClick={onConnectClick}
                    >
                        {buttonText}
                    </button>
                    {!!error && (
                        <ErrorMessageBlock className="mt-4">
                            <div className="mb-2">
                                Error, unable to process payments. Please try
                                reconnecting.
                            </div>
                            {error}
                        </ErrorMessageBlock>
                    )}
                    {isConnected && (
                        <div className="mt-2">
                            {subtitle1 && (
                                <div className="mt-2">{subtitle1}</div>
                            )}
                            {subtitle2 && (
                                <div className="mt-2">{subtitle2}</div>
                            )}
                        </div>
                    )}
                </div>
            )}

            {!!featured && enabled && (
                <div className="flex justify-center -mb-8 mt-2">
                    <div className="px-2 py-1 rounded justify-center text-sm font-medium bg-yellow-200 uppercase text-yellow-600 flex items-center">
                        <StarIcon className="w-4 h-4 mr-2" />
                        Preferred
                    </div>
                </div>
            )}
        </div>
    );
};

export default PaymentProcessorCard;
